// Expression binds reference the source meshes; remap them to this avatar clone.
export function cloneMouthBindings(sourceScene, scene, manager, presets = { a: 'aa', i: 'ih', u: 'ou', e: 'ee', o: 'oh' }) {
  const originals = []
  const clones = []
  sourceScene.traverse(node => originals.push(node))
  scene.traverse(node => clones.push(node))
  const meshes = new Map(originals.map((node, index) => [node, clones[index]]))
  const bindings = []
  for (const [vowel, preset] of Object.entries(presets)) {
    const expression = manager?.getExpression(preset) || manager?.getExpression(vowel)
    for (const bind of expression?.binds || []) {
      for (const primitive of bind.primitives || []) {
        const mesh = meshes.get(primitive)
        if (mesh?.morphTargetInfluences?.[bind.index] === undefined) continue
        bindings.push({ mesh, index: bind.index, weight: bind.weight, vowel })
      }
    }
  }
  return bindings
}

export function applyMouthViseme(bindings, viseme, strength = 1) {
  for (const { mesh, index } of bindings) mesh.morphTargetInfluences[index] = 0
  for (const { mesh, index, weight, vowel } of bindings) {
    if (vowel === viseme) mesh.morphTargetInfluences[index] += weight * strength
  }
}
